import React from "react";
import { formatMessage } from "lib/globalize-util";
import classNames from "classnames";
import { DATATEST } from "constants/integration";
import { IButtonStyles, Label, mergeStyleSets, nuOrderTheme as theme, Icon, Button } from "@nuorder/components";

interface IOwnProps {
    text: string;
    onClick: () => void;
    disabled?: boolean;
}

export const ChooseDestinationButton: React.FunctionComponent<IOwnProps> = ({ text, onClick, disabled }) => {
    const classes = React.useMemo(
        () =>
            mergeStyleSets({
                textContainer: { display: "flex", flex: 1, alignItems: "center", width: "100%" },
                chooseText: {
                    flex: 1,
                    textAlign: "left",
                    color: theme.palette.textColor,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    marginRight: 12,
                },
                chooseIcon: {
                    display: "flex",
                    alignItems: "center",
                },
                hasIcon: {
                    marginLeft: 12,
                },
            }),
        []
    );

    const buttonStyles = React.useMemo<Partial<IButtonStyles>>(
        () => ({
            root: { width: "100%", borderRadius: 4, padding: "0px 16px" },
        }),
        []
    );

    const handleRenderText = React.useCallback(() => {
        return (
            <span key="textContainer" className={classes.textContainer}>
                {!!text && <Icon iconName="folder24" className={classes.chooseIcon} />}
                <span
                    className={classNames(classes.chooseText, { [classes.hasIcon]: !!text })}
                    data-test={DATATEST.FOLDERS.CHOOSE_DESTINATION_TEXT}
                >
                    {text || formatMessage("Please select")}
                </span>
                <Icon iconName="chevronRight14" className={classes.chooseIcon} />
            </span>
        );
    }, [classes, text]);

    return (
        <>
            <Label>{formatMessage("Choose destination")}:</Label>
            <Button
                styles={buttonStyles}
                disabled={disabled}
                onRenderText={handleRenderText}
                onClick={onClick}
                testId={DATATEST.FOLDERS.CHOOSE_DESTINATION_BTN}
            />
        </>
    );
};
